<div class="tarjeta animated fadeIn container-fluid" *ngIf="proyecto">
  <h1 class="titulo">
    {{ proyecto.nombre | uppercase}}
    <small class="fecha">
    </small>
  </h1>
  <hr>
  
  <div class="row align-items-center">
    <div class="col imagen">
      <img [src]="proyecto.img" alt="proyecto.nombre">
    </div>
    <div class="col descripcion">
      <p>
      {{ proyecto.descripcion }}
      </p>
  
    <a (click)="verPortafolio()" class='btn btnRegresar'>
      <i class="fas fa-arrow-left"></i>
      Atras
    </a>
    <a href="{{ proyecto.direccion }}" target="_blank" class='btn btnOnline'>
      <i class="fas fa-globe-americas"></i>
      Online
    </a>
    </div>
  </div>
</div>
